import { observer } from 'mobx-react'
import { Component } from 'react'
import ExceptionPage from './ExceptionPage'

const ErrorBoundary = observer(
  class ErrorBoundary extends Component<any, any> {
    constructor(props) {
      super(props)
      this.state = { hasError: false }
    }

    static getDerivedStateFromError(error) {
      return { hasError: true }
    }

    render() {
      if (this.state.hasError) {
        return <ExceptionPage />
      }

      return this.props.children
    }
  }
)

export default ErrorBoundary
